import React from 'react';
import Stack from '@mui/joy/Stack';
import { SxProps } from '@mui/joy/styles/types';
import { LAYOUT } from '../theme/layoutTokens';

interface PageStackProps {
  children: React.ReactNode;
  spacing?: number;
  sx?: SxProps;
}

const PageStack: React.FC<PageStackProps> = ({ children, spacing = LAYOUT.stackSection, sx }) => {
  return (
    <Stack spacing={spacing} sx={{ width: '100%', minWidth: 0, ...sx }}>
      {children}
    </Stack>
  );
};

export default PageStack;
